import { Component } from '@angular/core';

@Component({
  selector: 'fgb-savings-page',
  templateUrl: './savings-page.component.html',
  styleUrl: './savings-page.component.scss',
})
export class SavingsPageComponent {}
